import styled from 'styled-components';

export const Page = styled.main`
  min-height: 100vh;
  padding: 0;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: #fff;
`;

export const Frame = styled.section`
  width: 100%;
  min-height: 100vh;
  padding: 58px 0 0px;
  background: #f8f9fa;
  position: relative;
  display: flex;
  flex-direction: column;

  @media (min-width: 671px) {
    padding-top: 75px;
  }
`;

export const Header = styled.header`
  width: min(1090px, calc(100% - 32px));
  height: 70px;
  position: absolute;
  top: 23px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0 37px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 2;
  background: #f8f9fa;

  @media (max-width: 670px) {
    width: calc(100% - 24px);
    padding: 0 18px;
  }

  @media (min-width: 671px) {
    top: 40px;
    height: 70px;
    padding-left: 48px;
    padding-right: 48px;
  }
`;

export const KemiraLogo = styled.img`
  width: 91px;
  height: auto;
  object-fit: contain;

  @media (min-width: 671px) {
    width: 112px;
  }
`;

export const HeaderText = styled.span`
  margin-right: 0;
  color: #566170;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  line-height: 100%;
  letter-spacing: 0;

  @media (max-width: 670px) {
    max-width: 145px;
    text-align: right;
    white-space: normal;
  }
`;

export const Hero = styled.section`
  width: min(1220px, 100%);
  height: 802px;
  margin: 0 auto;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  @media (max-width: 670px) {
    height: 802px;
  }
`;

export const HeroContent = styled.div`
  width: min(653px, 100%);
  margin-top: 46px;

  @media (max-width: 670px) {
    width: calc(100% - 32px);
    margin-top: 0;
  }

  @media (min-width: 671px) {
    margin-top: 29px;
  }
`;

export const Title = styled.h1`
  margin: 0;
  color: #fff;
  font: 700 38px/1.08 'Inter', sans-serif;
  letter-spacing: -1px;

  @media (min-width: 671px) {
    line-height: 48px;
  }
`;

export const Subtitle = styled.p`
  margin: 4px 0 24px;
  color: #fff;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  line-height: 100%;
  letter-spacing: 0;
  white-space: nowrap;

  @media (max-width: 670px) {
    white-space: normal;
  }

  @media (min-width: 671px) {
    margin-top: 8px;
    margin-bottom: 24px;
    line-height: 19px;
  }
`;

export const Form = styled.form`
  display: flex;
  gap: 11px;

  @media (max-width: 670px) {
    flex-direction: column;
    gap: 12px;
  }

  @media (min-width: 671px) {
    gap: 14px;
  }
`;

export const Input = styled.input`
  width: 456px;
  min-width: 456px;
  height: 40px;
  border: 1px solid #d9dfe5;
  padding: 0 12px;
  background: #fff;
  color: #28323d;
  font: 400 11px 'Inter', sans-serif;

  &::placeholder { color: #a3adb8; }
  &:focus { border-color: #168ed1; box-shadow: 0 0 0 2px #168ed133; }

  @media (min-width: 671px) {
    height: 42px;
    padding-left: 16px;
    padding-right: 16px;
  }

  @media (max-width: 670px) {
    width: 100%;
    min-width: 0;
  }
`;

export const SubmitButton = styled.button`
  width: 183px;
  min-width: 183px;
  height: 42px;
  min-height: 42px;
  padding: 0 18px;
  border: 0;
  background: #008bd2;
  color: #fff;
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 600;
  font-style: normal;
  line-height: 100%;
  letter-spacing: 0;
  transition: background .2s ease, transform .2s ease;

  &:hover { background: #0078b7; }
  &:active { transform: translateY(1px); }
  &:disabled { opacity: .7; cursor: wait; }

  @media (max-width: 670px) {
    width: 100%;
  }
`;

export const Message = styled.p`
  min-height: 17px;
  margin: 8px 0 0;
  color: #fff;
  font: 600 11px 'Inter', sans-serif;

  @media (min-width: 671px) {
    min-height: 0;
    height: 0;
    margin: 0;
    overflow: visible;
  }
`;

export const Footer = styled.footer`
  width: min(1220px, 100%);
  height: 45px;
  margin: 0 auto;
  padding: 22px 25px 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  @media (max-width: 670px) {
    padding-left: 16px;
    padding-right: 16px;
  }

  @media (min-width: 671px) {
    height: 85px;
    padding: 32px 32px 0;
  }
`;

export const Copyright = styled.span`
  color: #536071;
  font: 400 9px 'Inter', sans-serif;
`;

export const WebcolLogo = styled.img`
  width: auto;
  height: auto;
  object-fit: contain;
  opacity: .72;
`;
